import React from 'react'

function LeaderShipPage() {
  return (
    <div>LeaderShipPage</div>
  )
}

export default LeaderShipPage